import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "dj_window_block2" }

import { ref } from 'vue'
import { useStore } from 'vuex'
import { getNewsTypeList } from '@/config/request'
import News from './news.vue'
import Dynamic from './dynamic.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()

/* const newsName1 = '党建要闻'
const textList = ['党建动态','纪检监察','党务知识','热点时评'] */

let newsTypeId = ref('') //  新闻类型id
let list1 = ref([]) as any //  党建要闻
let list2 = ref([]) as any //  其他
let newsName1 = ref('党建要闻')

const init = async() => {
    const newsTypeList = await store.dispatch('getNewsType') as any
    newsTypeList.forEach((res:any)=>{
        if(res.themeName === '党建之窗'){
            newsTypeId.value = res.id
            return false
        }
    })
    getNewsList()
}
const getNewsList = async() => {
    const param = {
        id: newsTypeId.value
    }
    const res = await getNewsTypeList(param) as any
    const list = res.result
    list1.value = list.slice(0,1)
    list2.value = list.slice(1)
    newsName1.value = list1.value[0]?.name

}

init()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "container mar_b" }, [
        _createElementVNode("div", { class: "t6_breadCream" }, [
          _createElementVNode("span", null, "首页"),
          _createElementVNode("i", null, ">"),
          _createTextVNode(),
          _createElementVNode("span", null, " 党建之窗")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(News, {
          title: _unref(newsName1),
          newsTypeId: _unref(newsTypeId)
        }, null, 8, ["title", "newsTypeId"]),
        _createElementVNode("dl", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list2), (item, i) => {
            return (_openBlock(), _createElementBlock("dd", { key: i }, [
              _createVNode(Dynamic, {
                title: item.name,
                newsTypeId: _unref(newsTypeId)
              }, null, 8, ["title", "newsTypeId"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})